import axios from 'axios'
import HTTP from './http'

export default {
    getPayments: (payload) => axios.get(HTTP.GET_AGENT_PAYMENTS, { params: { ...payload } }),
    updatePayments:  (payload) => axios.patch(HTTP.UPDATE_AGENT_PAYMENTS, { payload }),
    getLastPayment: (payload) => axios.get(HTTP.GET_LAST_PAYMENT, { params: { ...payload } }),
    publishPayments: (payload) => axios.post(HTTP.PUBLISH_PAYMENTS, payload),
    payAgentList: (payload) => axios.post(HTTP.PAY_AGENT_LIST, payload)
}
